const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/visits',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: true
}

export default appConfig